import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo";
import LangProvider from "./context/lang-context";
import LandingPage from "./pages/home/LandingPage";
import NewPassPage from "./pages/new_pass";
import RestaurantMenuPage from "./pages/restaurant/RestaurantMenuPage";
import SharedCartPage from "./pages/shared-cart/SharedCartPage";
import DineInOrderPage from "./pages/dine-in/DineInOrderPage";
import PaymentSuccessPage from "./pages/payment-success/PaymentSuccessPage";
import PayOrderPage from "./pages/pay/PayOrderPage";
import PaymentTipPage from "./pages/payment/PaymentTipPage";
import ContactPage from "./pages/contact/ContactPage";
import EmpresasRedirectPage from "./pages/empresas/EmpresasRedirectPage";

import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <ApolloProvider client={client}>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/new_pass" element={<NewPassPage />} />
            <Route path="/shared/:token" element={<SharedCartPage />} />
            <Route path="/mesa" element={<DineInOrderPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/pay/:partnerId/:orderId" element={<PayOrderPage />} />
            <Route path="/payment/:linkId" element={<PaymentTipPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/empresas" element={<EmpresasRedirectPage />} />
            <Route path="/:url_name" element={<RestaurantMenuPage />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </ApolloProvider>
  );
}

export default App;
